export default __webpack_public_path__ + "static/O0290-4fd4ef21bfd029eef98cbbd159b35162.png";